(() => {
  'use strict';
  const initialise = () => {
    const topic = new URLSearchParams(location.search).get('topic');
    if (['honey','bees','business','host','other'].includes(topic)) {
      const select = document.querySelector('.ghc-contact-form select');
      const option = select?.querySelector('[data-topic="' + topic + '"]');
      if (option && !select.value) select.value = option.value;
    }
    document.querySelectorAll('[data-reservation-total]').forEach(output => {
      const form = output.closest('form');
      const input = form.querySelector('[name="quantity"]');
      if (output.dataset.ready) return;
      output.dataset.ready = 'true';
      const currency = output.dataset.currency || 'GBP';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency, maximumFractionDigits:2});
      const update = () => {
        const quantity = Number(input.value);
        if (!input.validity.valid || !Number.isSafeInteger(quantity) || quantity < 1) {output.hidden=true;return;}
        const deposit = Number(output.dataset.price);
        const total = Number(output.dataset.total);
        output.hidden = quantity === 1 || currency !== 'GBP';
        output.textContent = output.dataset.template.replace('__count__',quantity).replace('__today__',money.format(deposit*quantity/100)).replace('__later__',money.format((total-deposit)*quantity/100)).replace('__total__',money.format(total*quantity/100));
      };
      input.addEventListener('input',update);
      update();
    });
    const outcome = document.querySelector('.ghc-contact-form [role="alert"],.ghc-contact-form [role="status"],.ghc-business-form [role="alert"],.ghc-business-form [role="status"]');
    if(outcome){outcome.tabIndex=-1;outcome.focus();}
  };
  initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
